<div class="search-results-item d-flex align-items-center">
  <a [group]="group">
    <div class="d-flex align-items-center">
      <div class="avatar">
        <img [src]="group.icon | baseUrl" class="img-fluid" />
      </div>
      <div>
        <div class="name">{{ group.name }}</div>
        <div class="desc">Age Group {{ group.agegroup?.name }} &bull; {{ group.members }} members</div>
      </div>
    </div>
  </a>
  <a href="" class="link ml-auto" (click)="onJoin(); false">
    {{ group.is_subscriber || group.is_requested ? 'Leave group' : 'Join group' }}
  </a>
</div>
